export default __webpack_public_path__ + "static/media/placeholder_dummy2016-klempner01-de.89b943e0.png";